import { IParameter } from '@/pages/Parameters/parameters.types'

const indicatorsParameters: Array<IParameter['sourceId']> = [
  'RKBRelayState',
  'shaftGuardState',
  'shaftDoorsState',
  'FCUpCmd',
  'FCDownCmd',
  'FCDECCmd',
  'FCLSCmd',
  'FCHSCmd',
  'FCSELTCmd',
  'FCRSTCmd',
  'FCBXSgl',
  'MDReadySgl',
  'MDRunSgl',
  'safetyChainState',
  'K7RelayState',
  'LKMCCmd',
  'KDSRelayState',
  'LKM2Cmd',
  'phaseControlRelayState',
  'ONKMCSgl',
  'LKM1Cmd',

  'VKODoorSideASgl',
  'VKZDoorSideASgl',
  'VBRDoorSideASgl',
  'doorControlSensorSideASgl',
  'MBMInstalledSideAFlag',
  'blockSideAFlag',
  'openDoorSideACmd',
  'closeDoorSideACmd',

  'VKODoorSideBSgl',
  'VKZDoorSideBSgl',
  'VBRDoorSideBSgl',
  'doorControlSensorSideBSgl',
  'MBMInstalledSideBFlag',
  'blockSideBFlag',
  'openDoorSideBCmd',
  'closeDoorSideBCmd',
]
const liftIndicatorsConfig = { indicatorsParameters }

export default liftIndicatorsConfig
